// extracted by mini-css-extract-plugin
export default {"memTable":"viewOrg_memTable__19w9i","invTable":"viewOrg_invTable__ZlkFq"};